import { useEffect, useState } from "react";
import { useQueryClient, QueryCacheNotifyEvent } from "@tanstack/react-query";
import {
  TutorialJourneyStatus,
  TutorialJourneyType,
} from "@growth-machine-llc/stridist-api-client";
import { TUTORIAL_JOURNEY_SINGLE_KEY } from "../../../routes/admin/onboardingTemplate/JourneyTemplate";

export const useJourneyStatus = (
  journeyType?: TutorialJourneyType,
): TutorialJourneyStatus | undefined => {
  const queryClient = useQueryClient();
  const queryKey = journeyType
    ? [TUTORIAL_JOURNEY_SINGLE_KEY, { type: journeyType }]
    : undefined;

  const getStatus = () => {
    if (!journeyType) return undefined;

    const data = queryClient.getQueryData<any>(queryKey!);
    // if our placeholder “not found” DTO
    if (data?.id === 0) return undefined;

    return data?.status as TutorialJourneyStatus | undefined;
  };

  const [status, setStatus] = useState<TutorialJourneyStatus | undefined>(
    getStatus,
  );

  useEffect(() => {
    setStatus(getStatus());
  }, [journeyType]);

  useEffect(() => {
    if (!journeyType) return;

    const unsubscribe = queryClient
      .getQueryCache()
      .subscribe((event: QueryCacheNotifyEvent) => {
        if (
          event?.query.queryKey[0] === TUTORIAL_JOURNEY_SINGLE_KEY &&
          event.query.queryKey[1]?.type === journeyType &&
          ["added", "updated", "removed"].includes(event.type)
        ) {
          setStatus(getStatus());
        }
      });

    return unsubscribe;
  }, [journeyType]);

  return status;
};
